module.exports = __webpack_public_path__ + "static/phone-8c47d8be577be10ca30128c285d3c8bd.png";